<div class="container-fluid">
  <div class="row">
    <div class="col-12">
      <h5 class="header"> <i class="fa fa-cogs"></i><b> Manage Permit & Document Type Links</b></h5>

    </div>

  </div>

  <div class="row">
    <label id="idCtype" class="control-label col-md-2 "><strong>Select Permit Type : </strong></label>
    <select class="form-control col-md-2 " id="idCtype" [(ngModel)]="selectedPermitType" (change)="onChange()">
      <ng-container  *ngFor="let cat of permits" >
        <option [ngValue]="cat" *ngIf="cat.is_active">
          <div>{{cat.code}} - {{cat.description}}</div>
        </option>
    </ng-container>
    </select>
    <textarea class="form-control col-md-4 input-s" placeholder="Description" [(ngModel)]="description">

</textarea>
  </div>
  <div class="row">
    <div class="col-6">
      <strong>This left pane shows all the available document types that can still be linked to the selected permit
        type. </strong>
    </div>
    <div class="col-6">
      <strong>This right-side pane shows all the document types that are already linked and therefore shown on the
        uploads screen. </strong>
    </div>
  </div>


  <div class="row">
    <div class="col-6" style="margin: 0px;padding: 0px;">
      <div class="row">
        <div class="col-12">
          <table class="table">
            <thead>

              <th class="tblhead">Code</th>
              <th class="tblhead">Description</th>
              <th class="tblhead border-right">Click To Link</th>

            </thead>
            <tbody>
              <ng-container  *ngFor="let x of doctypes.unlinked">
                <tr *ngIf="x.is_active">

                  <td class="tblbody">
                    {{x.code}}
                  </td>
                  <td class="tblbody">
                    {{x.description}}
                  </td>
                  <td class="tblbody border-right">
                    <span (click)="OnSaveLinks(x.id)" class="btn btn-info btn-sm"><i class="fa fa-pencil fa-fw"
                        aria-hidden="true"></i></span>
                  </td>



                </tr>
              </ng-container>
            </tbody>

          </table>
        </div>

      </div>

    </div>


    <div class="col-6" style="margin: 0px;padding: 0px;">
      <div class="row">
        <div class="col-12">
          <table class="table">

            <thead>



              <th class="tblhead">Code</th>
              <th class="tblhead">Description</th>
              <th class="tblhead border-right">Mandatory?</th>
              <th class="tblhead border-right">De-Link</th>

            </thead>
            <tbody>
              <tr *ngFor="let x of doctypes.PermitLinked">

                <td class="tblbody">
                  {{x.code}}
                </td>
                <td class="tblbody">
                  {{x.description}}
                </td>
                <td class="tblbody border-right">
                  <input type="checkbox" [(ngModel)]="x.is_mandatory" (click)="onUpdateLink($event,x.id,x)">
                </td>
                <td class="tblbody border-right">
                  <span (click)="onDelete(x.id,x.code)" class="btn btn-danger btn-sm"><i class="fa fa-link"
                      aria-hidden="true"></i></span>
                </td>


              </tr>
            </tbody>

          </table>
        </div>

      </div>

    </div>
  </div>
  <app-busy [message]="message" style="z-index:20000;position:relative;" *ngIf="isActivated"></app-busy>

  <!-- <div class="col-md-12">
    <br>
    <button title="Go Back" type="button" id="btnCancel" [routerLink]="['/home']" class="btn btn-md btn-info pull-right"
      style="width:10%; margin-left:10px; "><i class="fa fa-arrow-circle-left"></i> Back</button>
    <br>
    <br>
    <br>
  </div> -->
</div>
<div class="col-md-12">
  <br>
  <div class="cover-x pull-right">
    <div class="main-btn rounded-circle rmp-all" [routerLink]="['/home']" title="Close"
      style="margin: 0px auto!important;" rel="tooltip" data-placement="top">
      <span class="fa fa-times fa-2x" style="margin:5.5px auto;color:white!important;" aria-hidden="true"></span>
    </div>
    <div class="lbl-app" style="margin: 1px auto;">
      <span>Close</span>
    </div>
  </div>
  <br>
  <br>
  <br>
</div>